import { useNavigate } from "react-router-dom";
import { AdminTemplate, ProductsComponent } from "../../components";

export const ProductsPage = () => {
  const navigate = useNavigate();
  const handleAddButton = () =>
    navigate("/product/add");

  return (
    <AdminTemplate
      headerProps={{
        headerTitle: "Ürün Listeleme",
        onClickAddButton: handleAddButton,
      }}
    >
      <ProductsComponent />
    </AdminTemplate>
  );
};
